import type { AxiosRequestConfig } from 'axios';
import api from '@/shared/utils/api';
import { useApiQuery } from '@/shared/hooks/useApiQuery';
import { useFeature } from '@/shared/features/useFeature';

/**
 * Teleprompter so existe com: flag `janus_meet` E flag `meet_teleprompter` (allowlist do BFF) E
 * `capabilities.teleprompter === true` (fato provado pelo backend, em GET /meet/capabilities).
 * A capacidade e lida CRUA aqui (sem tocar no normalizador do modulo): ausente/malformada = desligado.
 */
export function readTeleprompterCapability(data: unknown): boolean {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;
  const nested = typeof d.capabilities === 'object' && d.capabilities !== null ? (d.capabilities as Record<string, unknown>) : {};
  return d.teleprompter === true || nested.teleprompter === true;
}

export function useTeleprompterEnabled(): { enabled: boolean; loading: boolean } {
  const meet = useFeature('janus_meet');
  const tp = useFeature('meet_teleprompter');
  const flagsOn = meet.enabled && tp.enabled;
  const caps = useApiQuery(
    ['meet', 'teleprompter', 'capability'],
    async () =>
      readTeleprompterCapability(
        (await api.get('/meet/capabilities', { __skipErrorNotification: true, __skipRetry: true } as AxiosRequestConfig)).data,
      ),
    { enabled: flagsOn, staleTime: 60_000, retry: false },
  );
  const loading = meet.loading || tp.loading || (flagsOn && caps.isLoading);
  return { enabled: flagsOn && caps.data === true, loading };
}
